/**
 * Custom Placement Info Component
 *
 * Displays information about custom placement options.
 * Single Responsibility: Render placement info alert
 */
import { Alert, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

export const CustomPlacementInfo = () => {
  return (
    <Alert variant="light" color="blue" icon={<IconInfoCircle />}>
      <Text size="sm" fw={500} mb="xs">Custom Placement</Text>
      <Text size="sm" mb="xs">
        For custom placement, disable the automatic display options below and use one of these methods:
      </Text>
      <Text size="sm" component="ul" style={{ paddingLeft: '20px', margin: '8px 0' }}>
        <li style={{ marginBottom: '4px' }}>
          Search for "Free Shipping Bar" in the Block Editor (Gutenberg)
        </li>
        <li style={{ marginBottom: '4px' }}>
          Use shortcode <Text component="span" c="blue" fw={600}>[revoty_free_shipping_bar]</Text> in any page/post
        </li>
        <li>
          Use PHP function <Text component="span" c="blue" fw={600}>do_shortcode('[revoty_free_shipping_bar]')</Text> in theme files
        </li>
      </Text>
    </Alert>
  );
};
